<div [formGroup]="formGroup">
    <mat-checkbox formControlName="samtykkeTekstAccepteret" class="accepter-vilkaar" id="mat-checkbox-samtykke"
        >Jeg giver mit samtykke til følgende vilkår:</mat-checkbox
    >
    <div class="vilkaar" [innerHTML]="samtykkeTekst"></div>
</div>
